import { Checkbox, Table } from 'antd';
import React from 'react';

export default function Permission({ parentData, rawData, childData, status }) {
    const renderCheckboxColumn = (permissionType) => ({
        title: permissionType.charAt(0).toUpperCase() + permissionType.slice(1),
        dataIndex: 'roleId',
        key: permissionType,
        align: 'center',
        render: (_, record) => {
            const isChecked = parentData.some(role =>
                role.permissionName === record.roleName &&
                role.permissionLevel.includes(permissionType)
            );

            let checked = isChecked;

            if (record.parent && record.children?.length > 0) {
                // Parent is checked only if all children have the permission
                const allChildrenChecked = record.children.every(child =>
                    parentData.some(role =>
                        role.permissionName === child.roleName &&
                        role.permissionLevel.includes(permissionType)
                    )
                );
                checked = allChildrenChecked;
            }

            return (
                <Checkbox
                    disabled={status}
                    checked={checked}
                    onChange={(e) => {
                        const checked = e.target.checked;

                        if (record.parent && record.children?.length > 0) {
                            record.children.forEach(child => {
                                childData(child.roleName, permissionType, checked);
                            });
                        } else {
                            childData(record.roleName, permissionType, checked);
                        }
                    }}
                />
            );
        },
        width: 80
    });


    const renderSelectAllColumn = {
        title: 'Select All',
        key: 'selectAll',
        align: 'center',
        render: (_, record) => {
            const permissionTypes = ['create', 'view', 'edit', 'Active / Inactive', 'delete'];
            // const isAllChecked = permissionTypes.every(type => 
            //     parentData.some(role => role.permissionName === record.roleName && role.permissionLevel.includes(type))
            // );
            const getAllRolesUnderRecord = () => {
                const roles = [record]; // include current row
                if (record.parent && record.children?.length > 0) {
                    roles.push(...record.children); // include children
                }
                return roles;
            };

            const isAllChecked = getAllRolesUnderRecord().every(role =>
                permissionTypes.every(type =>
                    parentData.some(p =>
                        p.permissionName === role.roleName && p.permissionLevel.includes(type)
                    )
                )
            );

            return (
                <Checkbox
                    disabled={status}
                    checked={isAllChecked}
                    onChange={(e) => {
                        const checked = e.target.checked;

                        const applyPermissions = (recordItem) => {
                            permissionTypes.forEach(type => {
                                childData(recordItem.roleName, type, checked);
                            });
                        };

                        // Apply to the current row
                        applyPermissions(record);

                        // If parent, apply to children too
                        if (record.parent && record.children?.length > 0) {
                            record.children.forEach(child => {
                                applyPermissions(child);
                            });
                        }
                    }}
                />
            );
        },
        width: 80
    };
    
    const columns = [
        {
            title: 'Permission List',
            dataIndex: 'roleName',
            key: 'roleName',
            width: 60
        },
        renderSelectAllColumn,
        renderCheckboxColumn('create'),
        renderCheckboxColumn('view'),
        renderCheckboxColumn('edit'),
        renderCheckboxColumn('Active / Inactive'),
        renderCheckboxColumn('delete'),
    ];

    return (
        <Table
            columns={columns}
            dataSource={rawData}
            scroll={{ x: 'max-content' }}
            pagination={false}
        />
    );
}
